import { SidebarMenuMain } from './SidebarMenuMain';

const SidebarMenu = () => {
  return (
    <div className="app-sidebar-menu overflow-hidden flex-column-fluid" style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <div
        id="kt_app_sidebar_menu_wrapper"
        className="app-sidebar-wrapper hover-scroll-overlay-y my-5"
        style={{ flex: '1 1 auto', overflow: 'auto' }}
        data-kt-scroll="true"
        data-kt-scroll-activate="true"
        data-kt-scroll-height="auto"
        data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
        data-kt-scroll-wrappers="#kt_app_sidebar_menu"
        data-kt-scroll-offset="5px"
        data-kt-scroll-save-state="true"
      >
        <div
          className="menu menu-column menu-rounded menu-sub-indention"
          id="#kt_app_sidebar_menu"
          data-kt-menu="true"
          data-kt-menu-expand="false"
        >
          <div className="px-5">
            <SidebarMenuMain />
          </div>
        </div>
      </div>
    </div>
  );
};

export { SidebarMenu };
